/* eslint-disable */
import { FIELD } from "@/data/constants";

export default [
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "userUsername",
    label: "Educator's DoE username",
    hint: "i.e. sally.citizen12",
    fieldRequired: true,
    validation: { required: true, regex: /^[^@]+$/ }
  },
  {
    fieldType: FIELD.FORM.DIVIDER
  },
  {
    fieldType: FIELD.INPUT.CHECK,
    name: "confirmUserWwcc",
    label: "Authorisation/Consent",
    validation: { required: true },
    options: [
      {
        value: true,
        text: "I confirm the educator has a valid and current Working with Children Check."
      }
    ]
  },
  {
    fieldType: FIELD.INPUT.CHECK,
    name: "confirmUserEmployee",
    label: "Authorisation/Consent",
    validation: { required: true },
    options: [
      {
        value: true,
        text: "I confirm this person is employed at my service and authorised to access information saved in the Self-Assessment and Quality Improvement Planning Portal platform."
      }
    ]
  },
  {
    fieldType: FIELD.INPUT.CHECK,
    name: "confirmInfoProvided",
    label: "Authorisation/Consent",
    validation: { required: true },
    options: [
      {
        value: true,
        text: " I declare that the information I have provided in this form is complete and correct and I understand that giving false or misleading information is a serious offence."
      }
    ]
  },
  {
    fieldType: FIELD.FORM.DIVIDER
  },
  {
    fieldType: FIELD.FORM.ACTIONS,
    buttons: [
      {
        label: "Create educator account",
        size: "large",
        appearance: "primary",
        action: "form:next"
      }
    ]
  }
];
